import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/renters/us/a-sticky-header-check-our-prices';
import { RentersPageTemplate } from '@/pageTemplate/RentersPageTemplate';
import { useEffect } from 'react';

export default function RentersPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  useEffect(
    () =>
      trackEventWithGeolocation('renters_page.viewed', {
        experiment: 'a-sticky-header-check-our-prices',
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <RentersPageTemplate config={config} />;
}
